<template>
  <wh-popup
    v-model="myVisible"
    :title="title"
    :ref-form="$refs.testReportForm"
    @close="hidePopup"
    @open="open"
  >
    <van-form ref="testReportForm" label-width="60px" class="form" @submit="submitForm">
      <wh-popup-select
        :show-text="form.certifyType"
        :show-picker.sync="picker.certifyType.show"
        name="certifyType"
        label="报告类型"
        :rules="rules.certifyType"
      >
        <template #select>
          <div class="certify-type-select">
            <van-field v-model="certifyTypeInput" class="custom" type="primary" size="small" placeholder="自定义" @keyup.enter="setCustomType">
              <template #button>
                <van-button icon="plus" size="mini" native-type="button" type="info" @click="setCustomType" />
              </template>
            </van-field>
            <van-picker
              show-toolbar
              :columns="certifyTypeColumns"
              :default-index="certifyTypeSelectIndex"
              @cancel="picker.certifyType.show = false"
              @confirm="onConfirm"
            />
          </div>
        </template>
      </wh-popup-select>
      <van-field v-model="form.reportName" :rules="rules.reportName" label="报告名称" />
      <van-field v-model="form.seriesNo" :rules="rules.seriesNo" label="报告编号" />
      <van-field v-model="form.certificationCompany" :rules="rules.certificationCompany" label="检测机构" />
      <wh-field-time-popup v-model="form.certificateDate" :rules="rules.certificateDate" label="颁发日期" />
      <van-field label="报告照片" :rules="rules.pic">
        <template #input>
          <wh-upload v-model="form.pic" :uploading.sync="picUploading" />
        </template>
      </van-field>
    </van-form>
  </wh-popup>
</template>

<script>
import { formPopup } from '@/utils/mixins/formPopup'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import WhPopupSelect from '@/components/public/WhPopupSelect/WhPopupSelect'
import { CERTIFY_TYPE } from '@/constant/common'
import WhFieldTimePopup from '@/components/public/WhFieldTimePopup/WhFieldTimePopup'
import WhUpload from '@/components/public/WhUpload/WhUpload'

export default {
  name: 'TestReportPopup',
  components: { WhUpload, WhFieldTimePopup, WhPopupSelect, WhPopup },
  mixins: [formPopup],
  props: {
    formIndex: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      form: {
        reportName: '',
        traceCode: '',
        seriesNo: '',
        certificationCompany: '',
        certificateDate: '',
        pic: [],
        certifyType: undefined,
        landId: undefined,
        cropId: undefined
      },
      rules: {
        certifyType: [
          {
            required: true, message: '请选择或自定义检测种类'
          }
        ],
        reportName: [
          {
            required: true, message: '请填写报告名称'
          }
        ],
        seriesNo: [
          {
            required: true, message: '请填写报告编号'
          }
        ],
        certificationCompany: [
          {
            required: true, message: '请填写报告检测机构'
          }
        ],
        certificateDate: [
          {
            required: true, message: '请选择报告颁发日期'
          }
        ],
        pic: [
          {
            required: true, message: '请上传报告照片'
          }
        ]
      },
      picUploading: false,
      picker: {
        certifyType: {
          show: false
        }
      },
      certifyTypeInput: '',
      certifyTypeColumns: [...CERTIFY_TYPE.filter(item => item.value !== 1)]
    }
  },
  computed: {
    title() {
      return this.formType === 'create' ? '新增权威检测' : '编辑权威检测'
    },
    certifyTypeSelectIndex() {
      for (const index in this.certifyTypeColumns) {
        if (this.certifyTypeColumns[index].value === this.form.certifyType) {
          return index
        }
      }
      return undefined
    },
    traceCode() {
      return this.$route.query.traceCode
    }
  },
  methods: {
    open() {
      if (this.formType === 'create') {
        this.formDataInit(this.form)
      } else {
        this.formDataInit(this.form, this.initFormData)
      }
      // 添加追溯码信息
      this.form.traceCode = this.traceCode
    },
    setCustomType() {
      const customType = this.certifyTypeInput

      if (customType) {
        if (!this.certifyTypeColumns.find(item => item.text === customType)) {
          this.certifyTypeColumns.push({
            text: customType,
            value: customType
          })
        }
        this.form.certifyType = customType
      }
      this.certifyTypeInput = ''
      this.picker.certifyType.show = false
    },
    submitForm() {
      if (this.picUploading) {
        this.$toast.loading('等待图片上完成')
        return
      }
      this.hidePopup()
      this.$emit('submit', this.form, this.formIndex)
    },
    onConfirm(val) {
      this.picker.certifyType.show = false
      this.form.certifyType = val.value
    }
  }
}
</script>

<style lang='less' scoped>
.form {
  margin-top: 20px;
}
.certify-type-select {
  position: relative;
  .custom {
    position: absolute;
    width: 200px;
    left: 0;
    right: 0;
    z-index: 9;
    margin: auto;
  }
}
</style>
